import React, { useState, useEffect, useRef } from 'react';
import './ApperView.css'
import ServiceBox from './ApperServiceBox/ApperServiceBox';

import { fetch_positions, fetch_services, update_positions, create_position, fetch_connections, create_connection, delete_connection } from './apperFunctions';
import Services from '../Services/Services';
import { sleep } from '../../../utils/general';
import Flow from '../../../components/flow/Flow';
import { ReactFlowProvider } from '@xyflow/react';
import SearchBar from '../../../components/SearchBar/SearchBar';
import ConnectionInfo from './connections/connectionInfo/ConnectionInfo.js';




const ApperView = ({ projectId }) => {

    const [services, setServices] = useState([])
    const [currentPage, setCurrentPage] = useState("main");
    const [positions, setPositions] = useState({});
    const [connections, setConnections] = useState([]);
    const [selectedConnection, setSelectedConnection] = useState([]);

    const [nodes, setNodes] = useState([])
    const [searchResults, setSearchResults] = useState([])
    const [focusedId, focus] = useState(0)
    

    useEffect(()=>{fetch_positions(projectId, setPositions)}, []);
    useEffect(()=>{fetch_connections(projectId, setConnections)}, []);
    useEffect(()=>{fetch_services(setServices, projectId)}, []);

    useEffect(()=>{
        const nodesTemp = [];
        services.map(service => {
            if(positions[service.id]){
            nodesTemp.push(
                { id: `${service.id}`, position: { x: positions[service.id].x, y: positions[service.id].y }, data: { 
                    id: service.id,
                    serviceInfo: service,
                }, type: 'serviceBox' })
            }
        });
        setNodes(nodesTemp)
    },[services])


    const refresh = async() => {
        await sleep(400);
        fetch_positions(projectId, setPositions)
        fetch_connections(projectId, setConnections)
        fetch_services(setServices, projectId)
    }

    return (
        <div className='apperview'>
            {currentPage === "main" && (
            <div className='apper-page' onClick={()=>{setSearchResults([])}}>
                <div className='apper-page-header'>
                    {/* <button className='connect-button' onClick={()=>{setConnecting(true);refresh()}}>← connect</button> */}
                    <button onClick={()=>{setCurrentPage("selectService")}} className='new-button glassmorphism'>+</button>
                    <SearchBar button={false} searchResults={searchResults} onSearch={(filter)=>{
                        if (filter === "") {
                                setSearchResults([]);
                            }
                            else{
                                fetch_services(setSearchResults, projectId, filter)
                            }}}
                            selectSearch={(service_id)=>{
                                focus(service_id)
                            }}/>  
                </div>
                <div className='apperview-canvas'>
                    <div className='flow-container'>
                        {(nodes.length !== 0 ) && 
                            <ReactFlowProvider>
                                <Flow nodeTypes={{ serviceBox: ServiceBox }} 
                                    initialNodes={nodes} 
                                    update_positions={
                                         
                                    (service_id, x, y)=>{
                                            var newPositions = {}
                                            if (!positions[service_id]) {
                                                fetch_positions(projectId, (positions) => {
                                                    newPositions = positions
                                                    newPositions[service_id] = {id :positions[service_id].id, x: x, y: y, project_id: projectId}
                                                    setPositions(newPositions);
                                                    update_positions(projectId, newPositions)
                                                })
                                            }
                                            else {
                                                newPositions = {...positions}
                                                newPositions[service_id] = {id :positions[service_id].id, x: x, y: y, project_id: projectId}
                                                setPositions(newPositions);
                                                update_positions(projectId, newPositions)
                                            }
                                            
                                    }}
                                    initialEdges={connections}
                                    focusedId={focusedId}
                                    focus={focus}
                                    onConnect={(source, target) => create_connection(projectId, Number(source), Number(target))}
                                    onDelete={(connection_id) => {delete_connection(connection_id);}}
                                    selectConn={conn=>{setSelectedConnection(conn); setCurrentPage("connInfo")}}
                                />
                            </ReactFlowProvider>
                        }
                    </div>
                </div>
                
                </div>
                )}
            {currentPage === "selectService" && <Services exclude={Object.keys(positions).map(Number)} projectId={projectId} select={true} selectService={async (service)=>{
                await create_position(projectId, service.service_id);
                setCurrentPage("main")
                refresh()
            }}/>}
            {currentPage === "connInfo" && <ConnectionInfo source={selectedConnection.source} target={selectedConnection.target}/>}
        </div>
    );
};

export default ApperView; 